import { useSyncExternalStore } from 'react';

/**
 * Tailwind's `md` screen: the width at which Layout swaps the phone menu for the
 * sidebar rail (`hidden md:flex` / `md:hidden` in Layout.tsx). One copy, so the
 * JS readers of the breakpoint cannot drift from the CSS one.
 */
export const DESKTOP_LAYOUT_QUERY = '(min-width: 768px)';

function subscribe(onChange: () => void): () => void {
  if (typeof window.matchMedia !== 'function') return () => {};
  const query = window.matchMedia(DESKTOP_LAYOUT_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

// No matchMedia (jsdom) reads as desktop, the layout every existing test assumes.
function isDesktop(): boolean {
  return typeof window.matchMedia !== 'function' || window.matchMedia(DESKTOP_LAYOUT_QUERY).matches;
}

/** True at the desktop layout, false at phone width; follows resizes. */
export function useIsDesktopLayout(): boolean {
  return useSyncExternalStore(subscribe, isDesktop, () => true);
}
